var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 0C6.49187 0 0 6.49197 0 14.4999C0 22.5074 6.49178 29 14.4996 29C22.5074 29 28.9998 22.5074 28.9998 14.4999C28.9998 6.49197 22.5074 0 14.4998 0ZM18.2916 21.0926C18.0271 21.3569 17.6805 21.4891 17.3344 21.4891C16.9881 21.4891 16.6414 21.3569 16.3772 21.0925L10.9354 15.651C10.8544 15.599 10.777 15.5394 10.7065 15.4686C10.4362 15.1981 10.3058 14.8423 10.3124 14.4881C10.3061 14.1336 10.4362 13.7776 10.7065 13.5073C10.7775 13.4366 10.8544 13.3769 10.9354 13.325L16.3528 7.90754C16.8816 7.37927 17.739 7.37907 18.2676 7.90783C18.7964 8.43631 18.7964 9.29354 18.2676 9.82259L13.602 14.4882L18.2917 19.178C18.8202 19.7067 18.8202 20.5639 18.2916 21.0926Z",
    fill: "#A25C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.8792891d.svg";
export { ForwardRef as ReactComponent };